import { render, staticRenderFns } from "./UserSmsNew.vue?vue&type=template&id=231a34b0&scoped=true&"
import script from "./UserSmsNew.vue?vue&type=script&lang=js&"
export * from "./UserSmsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a34b0",
  null
  
)

export default component.exports